import React from "react";
import {useTranslation} from "react-i18next";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";

export const TableEmptyRow = ({
    messageKey
}: any) =>{
    const {t} = useTranslation();
    return (
               <TableRow>
                        <TableCell align="center" colSpan={20}>{t(messageKey)}</TableCell>
        </TableRow>
    );
};
